import { Vendor } from '../types';

const EASTERN_STATES = [
  'CT', 'DE', 'FL', 'GA', 'IN', 'KY', 'MA', 'MD', 'ME', 'MI',
  'NC', 'NH', 'NJ', 'NY', 'OH', 'PA', 'RI', 'SC', 'TN', 'VA', 'VT', 'WV', 'DC',
];
const CENTRAL_STATES = ['AL', 'AR', 'IA', 'IL', 'KS', 'LA', 'MN', 'MO', 'MS', 'ND', 'NE', 'OK', 'SD', 'TX', 'WI'];
const MOUNTAIN_STATES = ['AZ', 'CO', 'ID', 'MT', 'NM', 'UT', 'WY'];
const PACIFIC_STATES = ['CA', 'NV', 'OR', 'WA'];

/**
 * Guess the timezone abbreviation based on a vendor's location address.
 * Returns a timezone string like "ET (UTC-5)" or empty string if unknown.
 */
export function guessTimezone(vendor: Vendor | undefined): string {
  if (!vendor) return '';

  const state = (vendor.loc_state || '').toUpperCase().trim();
  const country = (vendor.loc_country || '').toUpperCase().trim();

  if (country === 'US' || country === 'UNITED STATES') {
    if (EASTERN_STATES.includes(state)) return 'ET (UTC-5)';
    if (CENTRAL_STATES.includes(state)) return 'CT (UTC-6)';
    if (MOUNTAIN_STATES.includes(state)) return 'MT (UTC-7)';
    if (PACIFIC_STATES.includes(state)) return 'PT (UTC-8)';
    if (state === 'AK') return 'AKT (UTC-9)';
    if (state === 'HI') return 'HST (UTC-10)';
  }

  if (country === 'UK' || country === 'UNITED KINGDOM' || country === 'GB') return 'GMT (UTC+0)';
  if (country === 'DE' || country === 'GERMANY' || country === 'FR' || country === 'FRANCE') return 'CET (UTC+1)';

  return '';
}
